import BenefitCard from "./BenefitCard";
const cardDataList = [
    {
        'title': 'Home Tutions',
        'details': ['Easy Home Tutions', 'Familiar Teachers', 'Convinient Timmings', 'One on One Teaching'],
        'image': '/images/home-tution.jpg',
        'left': true,
    },
    {
        'title': 'Hobby Tutors',
        'details': ['Brush up your non academic skills', 'Pursue your Passion', 'Do whatever you love', 'Make yourself stand out of crowd'],
        'image': '/images/hobby-tutor.jpg',
        'left': false,
    },
    {
        'title': 'Live batch Tution',
        'details': ['Study favorable Environment', 'Well Qualified Teachers', 'Regular Doubt Solving', 'Convinient Pricing'],
        'image': '/images/live-batch-tutor.jpg',
        'left': true,
    }
]
function Benefits() {
    return (
        <div className="benefitsContainer">
            <BenefitCard cardData={cardDataList[0]}></BenefitCard>
            <BenefitCard cardData={cardDataList[1]}></BenefitCard>
            <BenefitCard cardData={cardDataList[2]}></BenefitCard>
        </div>
    );
}
export default Benefits;